import { Overlay, OverlayConfig, OverlayContainer, OverlayRef } from '@angular/cdk/overlay';
import { Portal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

type Direction = 'opening' | 'closing';

@Injectable({
  providedIn: 'root'
})
export class CdkPortalService {
  private readonly direction$ = new BehaviorSubject<Direction>(null);

  private _overlayRef: OverlayRef;

  constructor(private overlay: Overlay, private overlayContainer: OverlayContainer) {}

  openPortal<T>(portal: Portal<T>, config: OverlayConfig): OverlayRef {
    // Fixes issue when modal window container appears last in the dom that
    // causes weird behavior of other overlays (such as dropdowns)
    // due to the same value of z-index=1000
    this.overlayContainer.getContainerElement().style.zIndex = '999';

    if (this._overlayRef) {
      this.cleanUp();
    }

    this._overlayRef = this.overlay.create(config);
    this._overlayRef.attach(portal);
    return this._overlayRef;
  }

  closePortal(): void {
    this.cleanUp();
  }

  setDirection(value: Direction): void {
    this.direction$.next(value);
  }

  getDirection(): Direction {
    return this.direction$.value;
  }

  private cleanUp(): void {
    this._overlayRef?.dispose();
  }
}
